import InputBox from '../../component/InputBox';
import { useEffect, useRef, useState } from 'react';
import { modalType, convertModalType } from '../../util/ModalUtil';
import ButtonBox from '../../component/ButtonBox';
import SelectionBox from '../../component/SelectionBox';
import { useDispatch } from 'react-redux';
import { actionCodeAdd, actionCodeEdit } from '../../module/body/system/SystemCommonCodeModule';
import PopupRef from '../../component/PopupRef';

import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const CodeModal = ({ type, row, cdGrpId, cdGrpNm, modalRef }) => {
    const dispatch = useDispatch();
    const [cd, setCd] = useState(row && row.cd);
    const [cdNm, setCdNm] = useState(row && row.cdNm);
    const [sortSeq, setSortSeq] = useState(row && row.sortSeq);
    const [useStatusCd, setUseStatusCd] = useState(row && row.useStatusCd);
    const [cdPropDesc, setCdPropDesc] = useState(row && row.cdPropDesc);

    const popupRef = useRef(null);

    useEffect(() => {
        if (useStatusCd == undefined || useStatusCd == null || useStatusCd == '') {
            setUseStatusCd('ENABLED');
        }
        if (sortSeq == undefined || sortSeq == null || sortSeq == '') {
            setSortSeq(1);
        }
    }, []);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleConfirm = () => {
        if (cd == undefined || cd == null || cd == '') {
            popupRef.current.openAlert('코드를 입력하세요.');
        } else if (cdNm == undefined || cdNm == null || cdNm == '') {
            popupRef.current.openAlert('코드명을 입력하세요.');
        } else {
            if (type == modalType.ADD) {
                dispatch(actionCodeAdd({ cdGrpId, cd, cdNm, cdPropDesc, sortSeq, useStatusCd }));
            } else {
                dispatch(actionCodeEdit({ cdGrpId, cd, cdNm, cdPropDesc, sortSeq, useStatusCd }));
            }
            modalRef.current.close();
        }
    };

    return (
        <>
            <ModalHeader title={'코드 ' + convertModalType(type)} modalRef={modalRef} />

            <div className='modal-body'>
                <div className='con-inner CodeModal'>
                    <InfoTxt infoTxt={type == modalType.ADD ? '코드를 등록합니다.' : '코드를 수정합니다.'} />
                    <div className='form-box-row'>
                        <InputBox
                            title='코드그룹ID'
                            disabled
                            value={cdGrpId}
                            onChange={(e) => setGrpId(e.target.value)}
                        />
                    </div>
                    <div className='form-box-row'>
                        <InputBox
                            title='코드그룹명'
                            disabled
                            value={cdGrpNm}
                            onChange={(e) => setGrpNm(e.target.value)}
                        />
                    </div>
                    <div className='form-box-row'>
                        <InputBox
                            title='코드'
                            value={cd}
                            disabled={type == modalType.EDIT}
                            onChange={(e) => setCd(e.target.value)}
                        />
                    </div>
                    <div className='form-box-row'>
                        <InputBox title='코드명' value={cdNm} onChange={(e) => setCdNm(e.target.value)} />
                    </div>
                    <div className='form-box-row'>
                        <InputBox
                            title='코드속성설명'
                            value={cdPropDesc}
                            onChange={(e) => setCdPropDesc(e.target.value)}
                        />
                    </div>
                    <div className='form-box-row'>
                        <InputBox title='순번' number value={sortSeq} onChange={(e) => setSortSeq(e.target.value)} />
                    </div>
                    <div className='form-box-row'>
                        <SelectionBox
                            title='사용여부'
                            useAll={false}
                            value={useStatusCd}
                            options={[
                                { cd: 'ENABLED', cdNm: '사용' },
                                { cd: 'DISABLED', cdNm: '미사용' },
                            ]}
                            onChange={(e) => setUseStatusCd(e.target.value)}
                        />
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={() => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={() => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default CodeModal;
